'use strict';

function Util() {}
Util.setAttributes = function (el, attrs) {
  for (var key in attrs) {
    el.setAttribute(key, attrs[key]);
  }
};

(function () {
  var CountDown = function (element) {
    this.element = element;
    this.id = this.element.getAttribute('id') || 'default-countdown';
    this.labels = this.element.getAttribute('data-labels') ? this.element.getAttribute('data-labels').split(',') : [];
    this.intervalId;

    this.setVisibleLabels();
    this.createCountDown();

    this.days = this.element.getElementsByClassName('js-countdown__value--0')[0];
    this.hours = this.element.getElementsByClassName('js-countdown__value--1')[0];
    this.mins = this.element.getElementsByClassName('js-countdown__value--2')[0];
    this.secs = this.element.getElementsByClassName('js-countdown__value--3')[0];

    this.endTime = this.getEndTime();
    this.initCountDown();
  };

  CountDown.prototype.setVisibleLabels = function () {
    this.visibleLabels = this.element.getAttribute('data-visible-labels') ? this.element.getAttribute('data-visible-labels').split(',') : [];
    this.visibleLabels = this.visibleLabels.map(function (label) {
      return label.trim();
    });
  };

  CountDown.prototype.createCountDown = function () {
    var wrapper = document.createElement("div");
    Util.setAttributes(wrapper, {
      'aria-hidden': 'true',
      'class': 'countdown__timer'
    });

    for (var i = 0; i < 4; i++) {
      var timeItem = document.createElement("span"),
        timeValue = document.createElement("span"),
        timeLabel = document.createElement('span');

      timeItem.setAttribute('class', 'countdown__item');
      timeValue.setAttribute('class', 'countdown__value countdown__value--' + i + ' js-countdown__value--' + i);
      timeItem.appendChild(timeValue);

      if (this.labels && this.labels.length > 0) {
        timeLabel.textContent = this.labels[i].trim();
        timeLabel.setAttribute('class', 'countdown__label');
        timeItem.appendChild(timeLabel);
      }

      wrapper.appendChild(timeItem);
    }

    this.element.insertBefore(wrapper, this.element.firstChild);
  };

  CountDown.prototype.getEndTime = function () {
    var storageKey = 'countdown-endTime-' + this.id;
    var saved = sessionStorage.getItem(storageKey);
    var endTime;

    if (saved) {
      endTime = Number(saved);
    } else {
      if (this.element.getAttribute('data-timer')) {
        var timerInMs = Number(this.element.getAttribute('data-timer')) * 1000;
        endTime = new Date().getTime() + timerInMs;
      } else if (this.element.getAttribute('data-countdown')) {
        var rawDate = this.element.getAttribute('data-countdown').trim();

        if (!rawDate.includes('T') && !rawDate.includes(':')) {
          rawDate = rawDate + 'T23:59:59';
        } else if (!rawDate.includes('T') && rawDate.includes(':')) {
          rawDate = rawDate.replace(' ', 'T');
        }

        var parts = rawDate.split('T');
        var dateParts = parts[0].split('-').map(p => p.padStart(2, '0'));
        rawDate = dateParts.join('-') + 'T' + parts[1];

        endTime = new Date(rawDate).getTime();
      } else {
        endTime = new Date().getTime();
      }

      sessionStorage.setItem(storageKey, endTime);
    }

    return endTime;
  };

  CountDown.prototype.initCountDown = function () {
    var self = this;
    this.intervalId = setInterval(function () {
      self.updateCountDown(false);
    }, 1000);
    this.updateCountDown(true);
  };

  CountDown.prototype.updateCountDown = function (bool) {
    var time = parseInt((this.endTime - new Date().getTime()) / 1000),
      days = 0,
      hours = 0,
      mins = 0,
      seconds = 0;

    if (isNaN(time) || time < 0) {
      clearInterval(this.intervalId);
      this.emitEndEvent();
    } else {
      days = parseInt(time / 86400);
      time = (time % 86400);
      hours = parseInt(time / 3600);
      time = (time % 3600);
      mins = parseInt(time / 60);
      seconds = parseInt(time % 60);
    }

    if (bool && days === 0 && this.visibleLabels.indexOf('d') < 0) this.days.parentElement.style.display = "none";
    if (bool && days === 0 && hours === 0 && this.visibleLabels.indexOf('h') < 0) this.hours.parentElement.style.display = "none";
    if (bool && days === 0 && hours === 0 && mins === 0 && this.visibleLabels.indexOf('m') < 0) this.mins.parentElement.style.display = "none";

    this.days.textContent = days;
    this.hours.textContent = this.getTimeFormat(hours);
    this.mins.textContent = this.getTimeFormat(mins);
    this.secs.textContent = this.getTimeFormat(seconds);
  };

  CountDown.prototype.getTimeFormat = function (time) {
    return ('0' + time).slice(-2);
  };

  CountDown.prototype.emitEndEvent = function () {
    var event = new CustomEvent('countDownFinished');
    this.element.dispatchEvent(event);
  };

  window.addEventListener('load', function () {
    var countDownEls = document.getElementsByClassName('js-countdown');
    for (var i = 0; i < countDownEls.length; i++) {
      new CountDown(countDownEls[i]);
    }
  });
})();